import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../../api/axiosInstance';
// Initial state
const initialState = {
  attachments: [],     
  status: 'idle',      
  error: null,          
};

// Async thunk for fetching attachments from API with dynamic parameters
export const fetchAttachments = createAsyncThunk(
  'attachments/fetchAttachments',
  async ({ customerFk, filter, search, start, length, language, token }) => {
    const payload = {
      customerFk: customerFk,
      attachmentType:filter,
      fromDate: null,
      toDate: null,
    };
    if (search) {
      payload.search = search;
    }
    const response = await axiosInstance.post(
      '/api/Customer/GetAttachments',
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          lang: language === "English" ? "2" : "1",
        },
      }
    );    
    const data = JSON.parse(response.data.message).Data;
    return data;
  }
);

// Slice for managing attachments
const attachmentSlice = createSlice({
  name: 'attachments',
  initialState,
  reducers: {
    resetAttachments: (state) => {
      state.attachments = [];
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAttachments.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAttachments.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.attachments = action.payload; // Store the fetched data
      })
      .addCase(fetchAttachments.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { resetAttachments } = attachmentSlice.actions;

export default attachmentSlice.reducer;
